export const DEFAULT_FIELDS_WARNING_MODAL_PROPS = {
  fullWidth: true,
  contentWidth: '300px',
  confirmButtonVariant: 'light',
} as const;
